import React from 'react';
import {
    Box,
    InputAdornment,
    MenuItem,
    Select,
    TextField,
} from '@mui/material';
import { Search } from '@mui/icons-material';
import { FormattedMessage, useIntl } from 'react-intl';

type SearchControlsProps = {
    query: string;
    setQuery: (q: string) => void;
    sortBy: string;
    setSortBy: (s: string) => void;
    onSearch: () => void;
};

const SearchControls = React.memo(
    ({ query, setQuery, sortBy, setSortBy, onSearch }: SearchControlsProps) => {
        const intl = useIntl();

        return (
            <Box
                display="grid"
                gridTemplateColumns="1fr auto"
                gap={1}
                alignItems="center"
            >
                <TextField
                    size="small"
                    placeholder={intl.formatMessage({ id: 'searchPatientIds' })}
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            onSearch();
                        }
                    }}
                    inputProps={{ autoComplete: 'off' }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                />
                <Select
                    size="small"
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                >
                    <MenuItem value="Name">
                        <FormattedMessage id="sortByName" />
                    </MenuItem>
                    <MenuItem value="ID">
                        <FormattedMessage id="sortById" />
                    </MenuItem>
                </Select>
            </Box>
        );
    }
);
SearchControls.displayName = 'SearchControls';

export default SearchControls;
